import i18n from 'l10n';
import GenericView from 'js/views/generic.view';
import Template from 'js/templates/group.tile.hbs';
import {on, tagName, template} from "../adapters/backbone-decorators";

@tagName('span')
@template(Template)
class GroupTileView extends GenericView {
    constructor(options) {
        super(options);
        this.options = options;
        this.model.bind("change", this.render, this);
    }

    updateUIForBlockingContact(el, size) {
        if (el.data("model").get('status') === 0) {
            $(el).find(".image-badge-small.icon-record").show();
            this.updateUI(el, size, ".toggle-block", "contacts.unblockcontact", 'status', '#count-blocked', "contacts.countBlocked");
        }
    }

    updateUIForEmailBouncingContact(el, size) {
        if (el.data("model").get('emailBounced') === 0) {
            $(el).find(".image-badge-small.fa-snowflake-o")
                .css('top', '0px')
                .css('left', '30px')
                .show();
            this.updateUI(el, size, ".toggle-email-bounce", "contacts.unbounceEmailContact", 'emailBounced', '#count-email-bounced', "contacts.countEmailBounced");
        }
    }

    changeButton(el, buttonClass, buttonTitle) {
        const $toggle = $(el).find(buttonClass)
            .prop('title', i18n.t(buttonTitle))
            .html('<i class="icon-cancel-2"></i>')
            .removeClass('success')
            .addClass('danger');
    }

    updateCounter(size, counterElementId, counterElementText) {
        const count = parseInt(size) + 1;
        $(counterElementId).text(i18n.t(counterElementText, {count: count}));
    }

    updateUI(el, size, buttonClass, buttonTitle, attribute, counterElementId, counterElementText) {
        this.changeButton(el, buttonClass, buttonTitle);
        el.data("model").set(attribute, 1);
        this.updateCounter(size, counterElementId, counterElementText);
    }

    updateUIForSmsBouncingContact(el, size) {
        if (el.data("model").get('smsBounced') === 0) {
            $(el).find(".image-badge-small.icon-locked")
                .css('top', '0')
                .css('left', '0')
                .show();
            this.updateUI(el, size, ".toggle-sms-bounce", "contacts.unbounceSmsContact", 'smsBounced', '#count-sms-bounced', "contacts.countSmsBounced");
        }
    }

    dropCallback(event, ui) {
        if (this.model.get("groupType") === "enum") {
            const el = ui.draggable;
            const size = this.$('#size-contact').text(); // Getting the size of the group before we try to add a contact.
            this.model.addContactToGroup(el.data("model").get("subscriptionId"), this.model.get('description'), el.data("model").get('subscriber').email);
            if (this.model.id === 1) {
                this.updateUIForBlockingContact(el, size);
            } else if (el.data("model").get('subscriber').email && this.model.get('description') === "BOUNCED EMAILS") {
                this.updateUIForEmailBouncingContact(el, size);
            } else if (el.data("model").attributes.msisdn && this.model.get('description') === "BOUNCED SMS") {
                this.updateUIForSmsBouncingContact(el, size);
            }
        } else {
            $.Notify.show(i18n.t("groups.cannotaddtocalculated") + '.');
        }
    }

    render() {
        super.render();
        this.$el.find('.tile').droppable({
            drop: this.dropCallback.bind(this)
        });
        const deletionBtn = this.$(".delete");
        const deletionMessage = i18n.t("groups.cannotdelete");
        if (deletionBtn) {
            if (this.options.referenced) {
                deletionBtn.attr({"disabled": true, "title": deletionMessage});
            } else {
                deletionBtn.attr({"disabled": false});
            }
        }
        this.$('[data-i18n]').i18n();
    }

    @on('click')
    viewGroup() {
        const theId = this.model.get(this.model.idAttribute);
        document.location.href = `/CampaignCloud/cloudui/home/Contacts.htm#Group/${theId}`;
    }
}

export default GroupTileView;
